import { IVocabulary, IVocabularyRow } from '../Types/VocabularyTypes'
import { useAppDispatch } from '../hooks'
import { useCallback } from 'react'
import { editCurrentVocabulary, VocabularyOperation } from '../Store/VocabulariesSlice'
import { stopGame } from '../Store/GameSlice'

export function useVocabularyActions(currentVocabulary: IVocabulary | null, currentRow: { index?: number } | null) {
  const dispatch = useAppDispatch()

  const action = useCallback((operation: VocabularyOperation | 'flipRow') => {
    if (!currentVocabulary) return
    const position = currentRow?.index || 0
    if (position >= currentVocabulary.rows.length) {
      return // invalid position
    }
    let data
    if (['addRow', 'deleteRow'].includes(operation)) {
      dispatch(stopGame())
      data = { position }
    } else {
      data = { position, row: currentVocabulary.rows[position] }
    }
    if (operation === 'flipRow') {
      operation = 'updateRow'
      if (!data.row) return
      const row = data.row
      data = { position, row: { ...data.row, left: row.right, right: row.left } }
    }
    dispatch(editCurrentVocabulary({ operation, data }))
  }, [dispatch, currentVocabulary, currentRow])

  const handleVocabularyChange = useCallback((data: {
    operation: VocabularyOperation
    position?: number,
    row?: IVocabularyRow,
    rows?: IVocabularyRow[],
  }) => {
    if (data.operation === 'updateRow') {
      const { position, row } = data
      dispatch(editCurrentVocabulary({ operation: 'updateRow', data: { position, row } }))
    }
    if (data.operation === 'addRow') {
      const { position } = data
      dispatch(editCurrentVocabulary({ operation: 'addRow', data: { position } }))
    }
    if (data.operation === 'rearrangeRows') {
      const { rows } = data
      dispatch(editCurrentVocabulary({ operation: 'rearrangeRows', data: { rows } }))
    }
  }, [dispatch])

  return {
    action,
    handleVocabularyChange,
  }
}